import "./Shop.module.css";
import Header from "@/reusable_sections/Header";
import ShopTitle from "./sections/ShopTitle";
import ShopContent from "./sections/ShopContent";
import MainFooter from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <Header />
      <ShopTitle />
      <ShopContent />
      <MainFooter />
    </div>;
}